import type { HTMLAttributes, ReactNode } from 'react';

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  size?: 'default' | 'narrow';
};

export function Container({ children, className, size = 'default', ...props }: ContainerProps) {
  return (
    <div
      className={['container', size === 'narrow' ? 'container--narrow' : '', className]
        .filter(Boolean)
        .join(' ')}
      {...props}
    >
      {children}
    </div>
  );
}
